import React from "react";
import bgImg from "../../../assets/Rectangle05.png";

const cards = [
  {
    number: "01",
    text: (
      <>
        <span className="text-[#EDC14A]">Uterine Cancer</span>{" "}
        Studies have linked frequent use of chemical hair relaxers to an increased
        risk of uterine cancer.
      </>
    ),
    bg: "bg-[#FFFFFF]",
  },
  {
    number: "02",
    text: (
      <>
        <span className="text-[#EDC14A]">Ovarian Cancer</span>{" "}
        Exposure to endocrine-disrupting chemicals found in hair relaxers may
        increase the risk of ovarian cancer.
      </>
    ),
    bg: "bg-[#FFFFFF]",
  },
  {
    number: "03",
    text: (
      <>
        <span className="text-[#EDC14A]">Endometrial Cancer</span>{" "}
        Hormone-related cancers affecting the lining of the uterus have also been
        associated with long-term relaxer use.
      </>
    ),
    bg: "bg-[#FFFFFF]",
  },
];

const HairRelaxerOverview = () => {
  return (
    <section
      className="w-full font-[Quicksand] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {/* Desktop + Tablet */}
      <div className="hidden md:block w-full">
        <div className="max-w-[1440px] mx-auto px-[80px] py-[60px]">

          {/* Heading */}
          <h2 className="mb-6">
            <span className="text-[#0A1F8F] text-[35px] font-semibold capitalize">
              Overview of the{" "}
            </span>
            <span className="text-[#EDC14A] text-[35px] font-semibold capitalize">
              Hair Relaxer Cancer Lawsuit
            </span>
          </h2>

          {/* Description */}
          <p className="text-[#757575] text-[18px] font-medium leading-normal mb-8 max-w-[1200px]">
            Hair relaxers are chemical products used to straighten naturally
            textured or curly hair. Many of these products contain ingredients
            that may disrupt the body’s hormonal system.
            <br />
            Recent scientific studies have suggested that{" "}
            <span className="font-bold">
              long-term exposure to certain chemicals found in hair relaxers may
              increase the risk of hormone-related cancers, including uterine
              cancer
            </span>
            , ovarian cancer, and endometrial cancer.
            <br />
            Thousands of women across the United States are now pursuing legal
            claims alleging that manufacturers failed to adequately warn
            consumers about these potential risks.
          </p>

          {/* Subheading */}
          <h3 className="text-[#0A1F8F] text-[35px] font-semibold mb-8">
            Lawsuits Allege That Manufacturers Failed To Warn Consumers About
          </h3>

          <p className="text-[#757575] text-[18px] font-medium mb-8 max-w-[1200px]">
            These lawsuits claim that manufacturers failed to properly disclose
            the potential cancer risks associated with prolonged product use.
          </p>

          {/* Cards */}
          <div className="grid grid-cols-2 gap-8">
            {cards.map((card, index) => (
              <article
                key={card.number}
                className={`p-5 rounded-[10px] ${card.bg} shadow-sm border border-white flex flex-col justify-center ${
                  index === 2 ? "col-span-2" : ""
                }`}
              >
                <span className="text-[#0A1F8F] text-[24px] mb-2">
                  {card.number}
                </span>

                <p className="text-[#0A1F8F] text-[16px] font-medium leading-relaxed">
                  {card.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col w-full gap-6 px-4 py-8">

        {/* Mobile Heading */}
        <h2 className="text-left">
          <span className="text-[#0A1F8F] text-[24px] font-semibold">
            Overview of the{" "}
          </span>
          <span className="text-[#EDC14A] text-[24px] font-semibold">
            Hair Relaxer Cancer Lawsuit
          </span>
        </h2>

        {/* Mobile Description */}
        <p className="text-[#757575] text-[16px] font-medium leading-relaxed">
          Hair relaxers are chemical products used to straighten naturally
          textured or curly hair. Many of these products contain ingredients
          that may disrupt the body’s hormonal system.
          <br />
          Recent studies suggest that <span className="font-bold">long-term exposure to certain chemicals
          found in hair relaxers may increase the risk of hormone-related
          cancers, including uterine,</span>  ovarian, and endometrial cancer.
        </p>

        {/* Mobile Subheading */}
        <h3 className="text-[#0A1F8F] text-[22px] font-semibold capitalize">
          manufacturers failed to warn doctors and patients about severe risks
        </h3>

        <p className="text-[#757575] text-[16px] font-medium leading-relaxed">
          Several manufacturers have settled lawsuits or recalled products, yet thousands of affected women are still eligible to file claims. 
        </p>

        {/* Mobile Cards */}
        <div className="flex flex-col gap-4">
          {cards.map((card) => (
            <div
              key={card.number}
              className="bg-white rounded-[10px] border border-white p-4 shadow-sm"
            >
              <span className="text-[#0A1F8F] text-[20px] font-semibold block mb-2">
                {card.number}
              </span>

              <p className="text-[#0A1F8F] text-[16px] font-medium leading-relaxed">
                {card.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HairRelaxerOverview;